var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7147 3.3656L2.23971 8.28747C2.09095 8.32814 1.95835 8.41368 1.85996 8.53243C1.76157 8.65119 1.70219 8.79738 1.68989 8.95111C1.67759 9.10483 1.71298 9.25861 1.79124 9.3915C1.86949 9.52438 1.98681 9.62992 2.12721 9.69372L10.1522 13.4906C10.3094 13.5634 10.4357 13.6896 10.5085 13.8468L14.3053 21.8718C14.3691 22.0122 14.4747 22.1296 14.6076 22.2078C14.7404 22.2861 14.8942 22.3215 15.0479 22.3092C15.2017 22.2969 15.3479 22.2375 15.4666 22.1391C15.5854 22.0407 15.6709 21.9081 15.7116 21.7593L20.6335 4.28435C20.6708 4.15682 20.6731 4.02162 20.6401 3.8929C20.6072 3.76418 20.5403 3.64669 20.4463 3.55274C20.3524 3.45879 20.2349 3.39184 20.1062 3.35892C19.9774 3.32599 19.8422 3.3283 19.7147 3.3656V3.3656Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3965 13.6032L14.634 9.36572",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.2388aaae4ca1f00c916b6e3a70974f56.svg";
export { ForwardRef as ReactComponent };